import { Reveal, Overline } from "@/components/Reveal";
import { Check, X } from "lucide-react";

const ROWS = [
  ["Inversión inicial", "Desde $150,000 USD en local, obra e inventario", "Una fracción: licencia + capital de trabajo"],
  ["Local físico", "Obligatorio, con renta mensual fija", "Ninguno. Operación 100% digital"],
  ["Inventario", "Compra y depreciación de stock", "Cero inventario físico"],
  ["Personal en piso", "Nómina fija desde el día uno", "Equipo mínimo y flexible"],
  ["Generación de demanda", "A su cargo, marketing local", "Pauta en Meta Ads centralizada"],
  ["Tiempo de retorno", "24 – 48 meses típicos", "Estructura pensada para retorno más ágil"],
  ["Riesgo operativo", "Alto: costo fijo constante", "Bajo: costos variables y digitales"],
  ["Escalabilidad", "Limitada al metro cuadrado", "Digital, sin techo de aforo"],
];

export function Comparison() {
  return (
    <section id="comparison" data-testid="comparison-section" className="relative py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <Overline>Comparativo directo</Overline>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-midnight mt-6 leading-[1.05]">
            Kairós vs. la franquicia tradicional.
          </h2>
          <p className="font-sans text-lg font-light text-midnight/60 mt-6">
            Mismo espíritu emprendedor. Estructura de costo y riesgo completamente distinta.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-14">
          {/* Desktop / tablet table */}
          <div className="hidden md:block border border-midnight/10 overflow-hidden">
            <div className="grid grid-cols-12 bg-midnight">
              <div className="col-span-4 p-5 font-sans text-xs uppercase tracking-[0.2em] text-ivory/70 font-semibold">Criterio</div>
              <div className="col-span-4 p-5 font-sans text-xs uppercase tracking-[0.2em] text-ivory/70 font-semibold border-l border-ivory/10">Franquicia tradicional</div>
              <div className="col-span-4 p-5 font-sans text-xs uppercase tracking-[0.2em] text-ivory font-bold border-l border-crimson bg-crimson">Kairós Learning</div>
            </div>
            {ROWS.map(([crit, trad, kairos], i) => (
              <div key={crit} className={`grid grid-cols-12 border-t border-midnight/10 ${i % 2 ? "bg-white" : "bg-ivory"}`}>
                <div className="col-span-4 p-5 font-sans text-sm text-midnight font-medium">{crit}</div>
                <div className="col-span-4 p-5 font-sans text-sm font-light text-midnight/60 border-l border-midnight/10 flex items-start gap-2">
                  <X className="w-4 h-4 text-midnight/40 shrink-0 mt-0.5" /> <span>{trad}</span>
                </div>
                <div className="col-span-4 p-5 font-sans text-sm text-midnight font-medium border-l border-crimson/30 bg-crimson/[0.06] flex items-start gap-2">
                  <Check className="w-4 h-4 text-crimson shrink-0 mt-0.5" /> <span>{kairos}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Mobile stacked cards */}
          <div className="md:hidden space-y-4" data-testid="comparison-mobile">
            {ROWS.map(([crit, trad, kairos]) => (
              <div key={crit} className="border border-midnight/10 bg-white p-5">
                <div className="font-serif text-lg text-midnight font-semibold">{crit}</div>
                <div className="mt-4 flex items-start gap-2">
                  <X className="w-4 h-4 text-midnight/40 shrink-0 mt-0.5" />
                  <div><div className="text-xs uppercase tracking-wider text-midnight/50">Tradicional</div><div className="font-sans text-sm text-midnight/70 mt-1">{trad}</div></div>
                </div>
                <div className="mt-4 flex items-start gap-2 border-t border-midnight/10 pt-4">
                  <Check className="w-4 h-4 text-crimson shrink-0 mt-0.5" />
                  <div><div className="text-xs uppercase tracking-wider text-crimson font-bold">Kairós</div><div className="font-sans text-sm text-midnight mt-1">{kairos}</div></div>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
